import { useEffect, useState } from "react";
import { useNavigate, useParams, Link } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { api } from "../lib/api";

export default function RefRedirect() {
  const { code } = useParams();
  const navigate = useNavigate();
  const [invalid, setInvalid] = useState(false);

  useEffect(() => {
    let alive = true;
    api.get(`/ref/${code}`)
      .then((r) => { if (alive) navigate(r.data.redirect || `/register?ref=${code}`, { replace: true }); })
      .catch(() => { if (alive) setInvalid(true); });
    return () => { alive = false; };
  }, [code, navigate]);

  if (invalid) {
    return (
      <section className="section-dark min-h-[60vh] flex items-center justify-center px-4" data-testid="ref-invalid">
        <div className="text-center max-w-md">
          <h1 className="font-display text-2xl font-bold text-slate-100">Invalid referral link</h1>
          <p className="text-sm text-slate-400 mt-3">This partner referral link is incorrect or no longer active.</p>
          <Link to="/register" data-testid="ref-invalid-register-btn" className="btn-gold inline-block mt-6 !px-7 !py-3 text-sm">REGISTER DIRECTLY</Link>
        </div>
      </section>
    );
  }

  return (
    <section className="section-dark min-h-[60vh] flex items-center justify-center" data-testid="ref-redirecting">
      <div className="text-center">
        <Loader2 size={26} className="animate-spin text-gold mx-auto" />
        <p className="text-sm text-slate-400 mt-4">Opening your partner referral…</p>
      </div>
    </section>
  );
}
